
function sendClickInfoToAnalyticsCMS(componentName, variant, buttonText, buttonIdentifier, trackid, data, event) {
    let parentSection = event.target.closest('section');
    let clickedButton = event.target;
    let buttonClassName = clickedButton.className;
    if (parentSection && !buttonClassName.includes('disclaimerText')) {
        if (parentSection.className.includes('dancingBubble')) {
            applyDancingBubble(event, variant.includes('black') ? 'green' : 'white', true);
        }
    }

    const promoUrl = event.target.getAttribute('data-url');
    if(promoUrl && !orderViewModel.promosAndDeals.isPromoCodeApplied){
        if (orderViewModel.store.id && promoUrl.includes('locator')) {
            localStorage.setItem('promoUrl',promoUrl)
            applyPromoDeal(promoUrl);
        } else {
            window.location.href = promoUrl;
        }
    }
    if (!componentName && !trackid) {
        return;
    }

    analytics.cmsClickTrack(componentName, buttonText, buttonIdentifier, trackid, data, event);
    let closest = event.target.closest('.IsPromo');
    if (closest && closest.getAttribute('data-promo') == 'IsPromo') {
        if (orderViewModel.promosAndDeals.isPromoCodeApplied) {
            event.target.href = "javascript:void(0)";
            removeDancingBubble(null);
            modalShowId('#modal-info');
        }
    }
    if (promoUrl && orderViewModel.promosAndDeals.isPromoCodeApplied && !closest){
        window.location.href = promoUrl;
    }

}

function applyPromoDeal(url) {
    const urlObj = new URL(url);
    const promoCode = urlObj.searchParams.get('promoCode');
    const promoId = urlObj.searchParams.get('promoID');
    const propositionGuid = urlObj.searchParams.get('propositionGuid');
    let payload = {
        StoreId: subwayScript.checkSatelliteNumber(orderViewModel.store.id),
        SiteName: $('#hdnSiteName').val(),
        CartId: orderViewModel.currentOrder.cartId,
        IsPromoID:  promoId? true : false,
        IsPromoCode: promoCode ? true : false,
        IsDeal: true,
        Country: orderViewModel.store.storeCountry,
        Offers: [
            {
                PromoCode: promoCode,
                PropositionGuid: propositionGuid
            }
        ],
    };

    if(!promoId && !promoCode) {
        const updatedUrl = orderViewModel.store.id || orderViewModel.store.StoreId;
        const updatedStoreId = subwayScript.checkSatelliteNumber(updatedUrl);
        if(updatedStoreId){
            window.location.href = subwayScript.navigation.getMenuUrl(updatedStoreId);
        }else {
            window.location.href = url;
        }
        return false;
    }

    $.ajax({
        url: '/remoteorder/restaurant/applypromodeal',
        type: 'POST',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(payload),
        success: function (data) {
            removeDancingBubble(null);
            if (data.isDealApplied) {
                orderViewModel.showRedirectSuccessBanner = true;
                orderViewModel.redirectBannerMessage = Congrats;
                orderViewModel.promosAndDeals.isPromoCodeApplied = promoId ? true : orderViewModel.promosAndDeals.isPromoCodeApplied
                orderViewModel.save();
                window.location.href = getUrl();
            } else {
                document.querySelector('.continue-without-deal').textContent = data.continueWithoutDeal;
                document.querySelector('.participating-store').textContent = data.participatingStore;
                document.querySelector('.promotion-unavailable-text').textContent = data.promotionUnavailableText;
                document.querySelector('.view-participating-location').textContent = data.viewParticipatingLocation;
                modalShowId('#deal-modal-error-guest', true);
            }

        },
        error: function (jqXhr) {
            removeDancingBubble(null);
            subwayScript.showAjaxError(jqXhr);
        }
    });
}

function handleDealPopupCTA(ctaName, event) {
    if(ctaName === 'VPL'){
        applyDancingBubble(event, 'white', true)
        window.location.href = localStorage.getItem('promoUrl');
        localStorage.removeItem('promoUrl');
    }
    if(ctaName === 'CWD'){
        applyDancingBubble(event, 'gray', true)
        window.location.href = getUrl();
    }
}
